import React from 'react'
import { Typography, Grid } from '@material-ui/core'
import { useHomeStore } from 'context/HomeStore'
import { useInfoCardStyles } from './infoCard.styles'
import moment from 'moment/moment'
import { AsterChip } from 'asterX-UIkit/Chips'
import { colorStatusesByCode } from 'constants/constants'

const InfoCard = ({ isMobile = false }) => {
  const classes = useInfoCardStyles()

  const {
    homeStore: { requestList }
  } = useHomeStore()

  const infoDetails = [
    { label: 'Номер заявки', value: requestList.id },
    {
      label: 'Дата создания',
      value: requestList.createdDate
        ? moment(new Date(requestList.createdDate)).format('HH:mm, DD.MM.YYYY')
        : '-'
    },
    {
      label: 'Статус',
      value: (
        <AsterChip
          label={requestList.status || '-'}
          style={{
            ...colorStatusesByCode(requestList.status)
          }}
        />
      )
    },
    {
      label: 'Ответственный',
      value: requestList.adminFullname || 'Ожидаем...'
    },
    {
      label: 'Дата назначения',
      value: requestList.inProcessDate
        ? moment(new Date(requestList.inProcessDate)).format(
            'HH:mm, DD.MM.YYYY'
          )
        : 'Ожидаем...'
    },
    { label: 'Раздел', value: requestList.department },
    { label: 'Модуль', value: requestList.module },
    { label: 'Номер РЛ', value: requestList.dealId || '-' },
    { label: 'Описание проблемы/ошибки', value: requestList.description }
  ]

  return (
    <Grid item container>
      {!isMobile && (
        <Grid item container xs={12} md={12} style={{ marginBottom: 16 }}>
          <Typography variant={'subtitle1'}>Информация о заявке</Typography>
        </Grid>
      )}
      <Grid item container direction="column" className={classes.infoContainer}>
        {infoDetails.map((item, index) => (
          <Grid
            item
            container
            xs={12}
            sm={12}
            md={12}
            direction="row"
            alignItems="flex-start"
            style={{ marginBottom: 12 }}
          >
            <Grid item container xs={5} md={5}>
              <Typography key={`descr_${index}`} className={classes.descr}>
                {item.label}:
              </Typography>
            </Grid>
            <Grid item container xs={7} md={7}>
              <Typography
                key={`infoDescr_${index}`}
                className={classes.infoDescr}
              >
                {item.value}
              </Typography>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </Grid>
  )
}

export default InfoCard
